import { Injectable } from "@angular/core";
import { BehaviorSubject, Subscription, from } from "rxjs";
import { GetEshopOrdersCountGQL } from "src/app/eshop/adapters/eshop.generated";
import { AuthService } from "../auth/auth.service";
import { KQueryOptions } from "./rest.service";
import { RestService } from "./rest.service";

@Injectable()
export class EshopOrdersServiceCommon {
	public createdOrdersCount: BehaviorSubject<number>;
	public createdOrdersCountSubscription: Subscription;

	constructor(private authService: AuthService, private restService: RestService) {
		this.createdOrdersCount = new BehaviorSubject<number>(0);
	}

	public async getCreatedOrdersCount(clientEid: string): Promise<number> {
		let qry = new GetEshopOrdersCountGQL(this.restService);
		let queryData = await qry.fetch(
			{
				clientEid: clientEid,
				filter: 'status.code[eq]:CREATED'
			},
			{ showSpinner: false, error: false } as KQueryOptions
		).toPromise();

		if (queryData != null) {
			return queryData.data?.accounts?.getEshopOrdersCountUsingGET?.count ?? 0;
		}

		return 0;
	}

	public getCreatedOrders() {
		if (this.createdOrdersCountSubscription) { this.createdOrdersCountSubscription.unsubscribe(); this.createdOrdersCountSubscription = null; }

		if (this.authService.user && this.authService.user.selectedCompanyId) {
			this.createdOrdersCountSubscription = from(this.getCreatedOrdersCount(this.authService.user.selectedCompanyId)).subscribe((count) => {
				this.createdOrdersCount.next(count != null ? count : 0);
			});
		}
	}

	public get createdOrders(): number {
		if (this.createdOrdersCount != null && this.createdOrdersCount.value != null) {
			return this.createdOrdersCount.value;
		}
		return 0;
	}
}
